import config from '../config/index';
export const casaTurnedOffFeatures = config.turnedOffFeatures;
